/**
 * @generated SignedSource<<d85a49c7f38402894aab3862bff51413>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITPBanksListRefetchQuery$variables = {
  itpCode?: string | null | undefined;
  search?: string | null | undefined;
};
export type PaymentActiveITPBanksListRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPBanksList_query">;
};
export type PaymentActiveITPBanksListRefetchQuery = {
  response: PaymentActiveITPBanksListRefetchQuery$data;
  variables: PaymentActiveITPBanksListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itpCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itpCode",
    "variableName": "itpCode"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentActiveITPBanksListRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "PaymentActiveITPBanksList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentActiveITPBanksListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ITPBankConnection",
        "kind": "LinkedField",
        "name": "itpBanks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ITPBankEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ITPBank",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "providerParticipantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16296962ce8e2007fa3ac7ab68100ef0",
    "id": null,
    "metadata": {},
    "name": "PaymentActiveITPBanksListRefetchQuery",
    "operationKind": "query",
    "text": "query PaymentActiveITPBanksListRefetchQuery(\n  $itpCode: String\n  $search: String\n) {\n  ...PaymentActiveITPBanksList_query_2S1FEk\n}\n\nfragment PaymentActiveITPBanksList_query_2S1FEk on Query {\n  itpBanks(itpCode: $itpCode, search: $search) {\n    edges {\n      node {\n        providerId\n        providerParticipantId\n        name\n        logo\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9fd8e728284f8bf00ea5c314f2969526";

export default node;
